import { SET_HUB_DATA } from "../actions/hubActions";

const initialState = {};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_HUB_DATA:
      return { ...state, ...payload };
    default:
      return state;
  }
};
export default reducer;
